import { OnDestroy, Directive } from '@angular/core';
import { Subject } from 'rxjs';

@Directive()
// tslint:disable-next-line: directive-class-suffix
export abstract class SelfDestruct implements OnDestroy {
	destroyed = new Subject<void>();

	ngOnDestroy() {
		this.destroyed.next();
		this.destroyed.complete();
	}
}
